import { useContext } from 'react';

import { PathOptionsContext, SetPathOptionsContext } from '../context';

export const usePathOptions = () => useContext(PathOptionsContext)!;
export const useSetPathOptions = () => useContext(SetPathOptionsContext)!;